import {
  Breadcrumbs,
  CircularProgress,
  Container,
  IconButton,
  InputAdornment,
  TextField,
  Link as MuiLink,
} from "@mui/material";
import React, { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import PageLoader from "../app/PageLoader";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import { useGetDMSManufacturersBySettingsIdQuery } from "../../redux/reducer/features/Integration/DmsSetupSlice";
import PortalManufacturerItem from "./Common/PortalManufacturerItem";
import { StyledBreadcrumb } from "./EmbeddedParts";
import FactoryIcon from "@mui/icons-material/Factory";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";

declare const emergepay: any;
export const PortalManufacturers: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const setupId = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting.dmsSetupId
  );
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const storeUrl = useSelector(
    (state: AppState) => state.shoppingPortalReducer.storeUrl
  );

  const { data, refetch, isSuccess, isLoading } =
    useGetDMSManufacturersBySettingsIdQuery({
      dealerSettingsId: dmsSetup?.dealerSettings?.id ?? "",
    });

  return (
    <>
      <Container maxWidth="xl">
        <PageLoader isLoading={isLoading}></PageLoader>
        <Grid container>
          <Grid item md={12}>
            <Box minHeight={100} bgcolor={"#f3f3f3"}>
              <Grid container md={12}>
                <Grid p={5} md={6} item>
                  <Typography variant="h4" fontWeight="bold">
                    Part Finder
                  </Typography>
                </Grid>
                <Grid md={6} item p={5}>
                  <Box sx={{ display: "flex", gap: 2, float: "right" }}>
                    Filter By:
                    <MuiLink
                      onClick={() =>
                        navigate(
                          `/ShoppingPortal/PartsByManuacturer?store=${storeUrl}`
                        )
                      }
                      color="inherit"
                      underline="none"
                      style={{ cursor: "pointer" }}
                    >
                      <strong>Manufacturer</strong>
                    </MuiLink>
                    <MuiLink
                      onClick={() => {
                        navigate(
                          `/ShoppingPortal/PartsByCategory?store=${storeUrl}`
                        );
                      }}
                      color="inherit"
                      underline="none"
                      style={{ cursor: "pointer" }}
                    >
                      <strong>Category</strong>
                    </MuiLink>
                    <MuiLink
                      onClick={() => {
                        navigate(
                          `/ShoppingPortal/EmbeddedParts?store=${storeUrl}`
                        );
                      }}
                      color="inherit"
                      underline="none"
                      style={{ cursor: "pointer" }}
                    >
                      <strong>Search Filters</strong>
                    </MuiLink>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item md={12} mt={2}>
            <Breadcrumbs aria-label="breadcrumb">
              <StyledBreadcrumb
                label="Manufacturers"
                icon={<FactoryIcon fontSize="small" />}
              />
            </Breadcrumbs>
          </Grid>
          <Grid item md={12} mt={2}>
            <Box mt={1} mb={1}>
              <TextField
                id="search"
                name="search"
                placeholder="Search.."
                variant="standard"
                size="small"
                onKeyUp={(e: any) => {
                  // if (e.key === "Enter") {
                  //   handleSearch();
                  // } else if (e.key === "Backspace" && search === "") {
                  //   setPaging((paging: any) => ({ ...paging, pageIndex: 0 }));
                  // }
                }}
                onChange={(e: any) => {
                  setSearch(e.target.value);
                }}
                value={search}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {isLoading ? (
                        <CircularProgress size="1.2rem" color="inherit" />
                      ) : (
                        <IconButton
                          onClick={() => {
                            //handleSearch();
                          }}
                        >
                          <SearchIcon
                            sx={{ fontSize: "20px", cursor: "pointer" }}
                          />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Grid container mt={2} mb={5} spacing={3}>
              {data && data.entityList && data.entityList?.length > 0 ? (
                [...data.entityList]
                  ?.filter(
                    (n) =>
                      n.name
                        .toLocaleLowerCase()
                        .startsWith(search.toLocaleLowerCase()) &&
                      n.isPartManufacturer
                  )
                  ?.sort((a, b) => a.name.localeCompare(b.name))
                  ?.map((mfr) => (
                    <>
                      <Grid item md={2}>
                        <PortalManufacturerItem
                          manufacturer={mfr}
                        ></PortalManufacturerItem>
                      </Grid>
                    </>
                  ))
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export const searchOptions = {
  types: ["address"],
};
